//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 29/07/2022 12:15:16 **********
var ContasActions;
(function (ContasActions) {
    ContasActions["DELETE_CONTAS"] = "DeleteContas";
    ContasActions["DELETE_RANGE_CONTAS"] = "DeleteRangeContas";
    ContasActions["FILTER_CONTAS"] = "FilterContas";
    ContasActions["GET_CONTAS"] = "GetContas";
    ContasActions["GETWITHDISABLED_CONTAS"] = "GetWithDisabledContas";
    ContasActions["GET_BY_ID_CONTAS"] = "GetByIdContas";
    ContasActions["POST_CONTAS"] = "PostContas";
    ContasActions["PUT_CONTAS"] = "PutContas";
})(ContasActions || (ContasActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 29/07/2022 12:17:29 **********
var Centro_CustoActions;
(function (Centro_CustoActions) {
    Centro_CustoActions["DELETE_CENTRO_CUSTO"] = "DeleteCentro_Custo";
    Centro_CustoActions["DELETE_RANGE_CENTRO_CUSTO"] = "DeleteRangeCentro_Custo";
    Centro_CustoActions["FILTER_CENTRO_CUSTO"] = "FilterCentro_Custo";
    Centro_CustoActions["GET_CENTRO_CUSTO"] = "GetCentro_Custo";
    Centro_CustoActions["GETWITHDISABLED_CENTRO_CUSTO"] = "GetWithDisabledCentro_Custo";
    Centro_CustoActions["GET_BY_ID_CENTRO_CUSTO"] = "GetByIdCentro_Custo";
    Centro_CustoActions["POST_CENTRO_CUSTO"] = "PostCentro_Custo";
    Centro_CustoActions["PUT_CENTRO_CUSTO"] = "PutCentro_Custo";
    Centro_CustoActions["PUTRANGE_CENTRO_CUSTO"] = "PutRangeCentro_Custo";
    Centro_CustoActions["GETCENTROCUSTOBYIDCOLABORADOR_CENTRO_CUSTO"] = "GetCentroCustoByIdColaboradorCentro_Custo";
    Centro_CustoActions["GETBYCENTROCUSTOPROJETOECOLABORADORCENTRO_CUSTO"] = "GetbyCentroCustoProjetoEColaboradorCentro_Custo";
    Centro_CustoActions["GETBYCENTROCUSTOPROJETO"] = "GetbyCentroCustoProjetoCentro_Custo";
    Centro_CustoActions["GETWITHDISABLEDWITHDESPESAS_CENTRO_CUSTO"] = "GetWithDisabledWithDespesasCentro_Custo";
    Centro_CustoActions["GETCENTROCUSTOBYUSUARIO"] = "GetCentroCustoByUsuario";
    Centro_CustoActions["GETMERGE_PROJETO_CENTRO"] = "GetMergeProjetoCentro";
    Centro_CustoActions["GETMERGE_PROJETO_CENTRO_BY_COLABORADORID"] = "GetMergeProjetoCentroCustoByColaboradorId";
})(Centro_CustoActions || (Centro_CustoActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 29/07/2022 12:17:30 **********
var Plano_ContasActions;
(function (Plano_ContasActions) {
    Plano_ContasActions["DELETE_PLANO_CONTAS"] = "DeletePlano_Contas";
    Plano_ContasActions["DELETE_RANGE_PLANO_CONTAS"] = "DeleteRangePlano_Contas";
    Plano_ContasActions["FILTER_PLANO_CONTAS"] = "FilterPlano_Contas";
    Plano_ContasActions["GET_PLANO_CONTAS"] = "GetPlano_Contas";
    Plano_ContasActions["GETWITHDISABLED_PLANO_CONTAS"] = "GetWithDisabledPlano_Contas";
    Plano_ContasActions["GET_BY_ID_PLANO_CONTAS"] = "GetByIdPlano_Contas";
    Plano_ContasActions["GET_FROM_CONTA_PLANO_CONTAS"] = "GetFromContaPlano_Contas";
    Plano_ContasActions["POST_PLANO_CONTAS"] = "PostPlano_Contas";
    Plano_ContasActions["PUT_PLANO_CONTAS"] = "PutPlano_Contas";
    Plano_ContasActions["MOVE_PLANO_CONTAS"] = "Move_Plano_Contas";
})(Plano_ContasActions || (Plano_ContasActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 29/07/2022 12:17:30 **********
var Plano_Contas_TipoActions;
(function (Plano_Contas_TipoActions) {
    Plano_Contas_TipoActions["DELETE_PLANO_CONTAS_TIPO"] = "DeletePlano_Contas_Tipo";
    Plano_Contas_TipoActions["DELETE_RANGE_PLANO_CONTAS_TIPO"] = "DeleteRangePlano_Contas_Tipo";
    Plano_Contas_TipoActions["FILTER_PLANO_CONTAS_TIPO"] = "FilterPlano_Contas_Tipo";
    Plano_Contas_TipoActions["GET_PLANO_CONTAS_TIPO"] = "GetPlano_Contas_Tipo";
    Plano_Contas_TipoActions["GETWITHDISABLED_PLANO_CONTAS_TIPO"] = "GetWithDisabledPlano_Contas_Tipo";
    Plano_Contas_TipoActions["GET_BY_ID_PLANO_CONTAS_TIPO"] = "GetByIdPlano_Contas_Tipo";
    Plano_Contas_TipoActions["POST_PLANO_CONTAS_TIPO"] = "PostPlano_Contas_Tipo";
    Plano_Contas_TipoActions["PUT_PLANO_CONTAS_TIPO"] = "PutPlano_Contas_Tipo";
})(Plano_Contas_TipoActions || (Plano_Contas_TipoActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 05/09/2022 01:34:02 **********
var Material_ItensActions;
(function (Material_ItensActions) {
    Material_ItensActions["DELETE_MATERIAL_ITENS"] = "DeleteMaterial_Itens";
    Material_ItensActions["DELETE_RANGE_MATERIAL_ITENS"] = "DeleteRangeMaterial_Itens";
    Material_ItensActions["FILTER_MATERIAL_ITENS"] = "FilterMaterial_Itens";
    Material_ItensActions["GET_MATERIAL_ITENS"] = "GetMaterial_Itens";
    Material_ItensActions["GETWITHDISABLED_MATERIAL_ITENS"] = "GetWithDisabledMaterial_Itens";
    Material_ItensActions["GET_BY_ID_MATERIAL_ITENS"] = "GetByIdMaterial_Itens";
    Material_ItensActions["POST_MATERIAL_ITENS"] = "PostMaterial_Itens";
    Material_ItensActions["PUT_MATERIAL_ITENS"] = "PutMaterial_Itens";
})(Material_ItensActions || (Material_ItensActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 30/08/2022 11:43:45 **********
var PertencesActions;
(function (PertencesActions) {
    PertencesActions["DELETE_PERTENCES"] = "DeletePertences";
    PertencesActions["DELETE_RANGE_PERTENCES"] = "DeleteRangePertences";
    PertencesActions["FILTER_PERTENCES"] = "FilterPertences";
    PertencesActions["GET_PERTENCES"] = "GetPertences";
    PertencesActions["GETWITHDISABLED_PERTENCES"] = "GetWithDisabledPertences";
    PertencesActions["GET_BY_ID_PERTENCES"] = "GetByIdPertences";
    PertencesActions["POST_PERTENCES"] = "PostPertences";
    PertencesActions["PUT_PERTENCES"] = "PutPertences";
})(PertencesActions || (PertencesActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 22/09/2022 11:00:15 **********
var Material_DetalhesActions;
(function (Material_DetalhesActions) {
    Material_DetalhesActions["DELETE_MATERIAL_DETALHES"] = "DeleteMaterial_Detalhes";
    Material_DetalhesActions["DELETE_RANGE_MATERIAL_DETALHES"] = "DeleteRangeMaterial_Detalhes";
    Material_DetalhesActions["FILTER_MATERIAL_DETALHES"] = "FilterMaterial_Detalhes";
    Material_DetalhesActions["GET_MATERIAL_DETALHES"] = "GetMaterial_Detalhes";
    Material_DetalhesActions["GETWITHDISABLED_MATERIAL_DETALHES"] = "GetWithDisabledMaterial_Detalhes";
    Material_DetalhesActions["GET_BY_ID_MATERIAL_DETALHES"] = "GetByIdMaterial_Detalhes";
    Material_DetalhesActions["POST_MATERIAL_DETALHES"] = "PostMaterial_Detalhes";
    Material_DetalhesActions["PUT_MATERIAL_DETALHES"] = "PutMaterial_Detalhes";
})(Material_DetalhesActions || (Material_DetalhesActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 22/09/2022 04:56:41 **********
var DespesasActions;
(function (DespesasActions) {
    DespesasActions["DELETE_DESPESAS"] = "DeleteDespesas";
    DespesasActions["DELETE_RANGE_DESPESAS"] = "DeleteRangeDespesas";
    DespesasActions["FILTER_DESPESAS"] = "FilterDespesas";
    DespesasActions["GET_DESPESAS"] = "GetDespesas";
    DespesasActions["GETWITHDISABLED_DESPESAS"] = "GetWithDisabledDespesas";
    DespesasActions["GET_BY_ID_DESPESAS"] = "GetByIdDespesas";
    DespesasActions["POST_DESPESAS"] = "PostDespesas";
    DespesasActions["PUT_DESPESAS"] = "PutDespesas";
    DespesasActions["GETWITHDISABLEDBYIDMATERIAL_DESPESAS"] = "GetWithDisabledByIdMaterialDespesas";
})(DespesasActions || (DespesasActions = {}));
export { ContasActions, Centro_CustoActions, Plano_ContasActions, Plano_Contas_TipoActions, PertencesActions, Material_ItensActions, Material_DetalhesActions, DespesasActions, };
//# sourceMappingURL=ContEnums.js.map